import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import HierarchyStructureListLayer from "../components/HierarchyStructureListLayer";

const HierarchyStructurePage = () => {
  return (
    <>
      <MasterLayout pageTitle="Sites & Departments">
        <HierarchyStructureListLayer />
      </MasterLayout>
    </>
  );
};

export default HierarchyStructurePage;
